import { makeStyles } from "@material-ui/core/styles";
import Form from "@saleor/components/Form";
import SingleAutocompleteSelectField from "@saleor/components/SingleAutocompleteSelectField";
import useStateFromProps from "@saleor/hooks/useStateFromProps";
import { maybe } from "@saleor/misc";
import { SearchRunner_search_edges_node } from "@saleor/storeOrders/types/SearchRunner";
import {
  DeliveryTypeEnum,
  SmopOrderStatusEnum
} from "@saleor/types/globalTypes";
import createSingleAutocompleteSelectHandler from "@saleor/utils/handlers/singleAutocompleteSelectChangeHandler";
import * as React from "react";

const useStyles = makeStyles(
  () => ({
    RunnerListContentText: {
      display: "flex",
      flex: "none",
      flexDirection: "column",
      width: "10em"
    }
  }),
  { name: "RunnerList" }
);

interface RunnerFormData {
  runnerId: string;
  storeOrderId: string;
}

interface RunnerInitialFormData {
  runnerId: string;
  storeOrderId: string;
}

interface RunnerListProps {
  order: any;
  onAssignRunner: (orderId: string) => void;
  onSubmitRunner: (data: RunnerFormData) => void;
  runnerList: SearchRunner_search_edges_node[];
  fetchRunner: (query: string) => void;
  fetchMoreRunner: any;
  isOpsAdmin: boolean;
  disableAction: boolean;
  enableManageMallActions: boolean;
  setOrderMallId: React.Dispatch<React.SetStateAction<string>>;
}

const RunnerList: React.FC<RunnerListProps> = props => {
  const {
    order,
    onSubmitRunner,
    isOpsAdmin,
    runnerList,
    fetchMoreRunner,
    fetchRunner,
    disableAction,
    enableManageMallActions,
    setOrderMallId
  } = props;
  const classes = useStyles(props);
  const runnerInitialForm: RunnerInitialFormData = {
    runnerId: maybe(() => order.runner.id, null),
    storeOrderId: maybe(() => order.id, null)
  };

  const runnerChoices = maybe(
    () =>
      runnerList.map(rider => ({
        label: `${rider.firstName} ${rider.lastName}`,
        value: rider?.id
      })),
    []
  );

  const [runnerDisplayName, setRunnerDisplayName] = useStateFromProps(
    maybe(() => order?.runner)
      ? `${order?.runner?.firstName} ${order?.runner?.lastName} `
      : ""
  );

  const submitRunner = e => {
    onSubmitRunner({
      runnerId: e.target.value,
      storeOrderId: maybe(() => order.id, null)
    });
  };

  return (
    <>
      {(isOpsAdmin || enableManageMallActions) &&
      [
        DeliveryTypeEnum.EXPRESS,
        DeliveryTypeEnum.EXPRESS_LONG_DISTANCE,
        DeliveryTypeEnum.SAME_DAY
      ].includes(order?.order?.shippingMethod?.deliveryType) &&
      ![
        SmopOrderStatusEnum.COMPLETED,
        SmopOrderStatusEnum.CANCELED,
        SmopOrderStatusEnum.SHIPPED,
        SmopOrderStatusEnum.COLLECTED
      ].includes(order?.smopStatus) ? (
        <Form initial={runnerInitialForm} onSubmit={submitRunner}>
          {({ data: formData, change }) => {
            const handleSelectRider = createSingleAutocompleteSelectHandler(
              change,
              setRunnerDisplayName,
              runnerChoices
            );

            const handleFocus = () => {
              if (order?.order?.mall?.id) {
                setOrderMallId(order?.order?.mall?.id);
              }
            };

            return (
              <SingleAutocompleteSelectField
                idInputTxt="runnerTxt"
                label={formData.runnerId ? null : "Select Runner"}
                displayValue={runnerDisplayName}
                onChange={event => {
                  handleSelectRider(event);
                  submitRunner(event);
                }}
                choices={runnerChoices}
                name="runnerId"
                value={formData.runnerId || null}
                fetchChoices={fetchRunner}
                disabled={disableAction}
                retainChoices={true}
                onFocus={handleFocus}
                {...fetchMoreRunner}
              />
            );
          }}
        </Form>
      ) : (
        <div className={classes.RunnerListContentText}>
          {order?.runner ? (
            <>
              <span style={{ whiteSpace: "nowrap" }}>{`${
                order?.runner.firstName === null
                  ? "--"
                  : maybe(() => order?.runner.firstName, "-")
              } ${
                order?.runner.lastName === null
                  ? ""
                  : maybe(() => order?.runner.lastName, "")
              }`}</span>
              <span>{order?.runner?.contactNo}</span>
            </>
          ) : (
            "--"
          )}
        </div>
      )}
    </>
  );
};

export default RunnerList;
